import { atom } from "recoil";

const studentsAtom = atom({
  key: "users",
  default: null,
});

export { studentsAtom };
